import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setCurrentDocumentPageMediaViewer } from '../../../store/modules/media-viewer/actions';
import { ButtonOption } from '../../button/ButtonGroup';
import { selectMediaViewer } from '../../../store/modules/media-viewer/selectors';
import ButtonGroupSelect from '../../button/ButtonGroupSelect';
import styles from './styles';

const PageSelect = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const { currentDocumentPage, documentPageList } = useSelector(selectMediaViewer);

  const buttonPages: ButtonOption[] = documentPageList
    .map((page, index): ButtonOption => ({
      title: `Page ${page.id}`,
      disabled: false,
      onClick: () => dispatch(setCurrentDocumentPageMediaViewer(index)),
    }));

  return (
    <ButtonGroupSelect
      buttons={buttonPages}
      className={classes.groupAction}
      color="default"
      variant="text"
      overlay={false}
      currentIndex={currentDocumentPage}
    />
  );
};

export default PageSelect;
